angular
  .module('contrast.services.security', [])
  .factory('SecurityService', function (ProfileService) {
    return {
      buildSearchLogForm: function (length, start, form) {
        var data = {}
        if (length) {
          data.limit = length
        }
        if (start || start == 0) {
          data.offset = start
        }
        if (form.searchKeywords) {
          data.keyword = form.searchKeywords
        }
        if (form.startDate) {
          data.startDate = moment(
            form.startDate,
            ProfileService.getDateFormat().replace('dd', 'DD')
          ).format('YYYY-MM-DD')
        }
        if (form.endDate) {
          data.endDate = moment(
            form.endDate,
            ProfileService.getDateFormat().replace('dd', 'DD')
          ).format('YYYY-MM-DD')
        }
        return data
      }
    }
  })
